import { createAction, props } from "@ngrx/store";
import {
  RoomBrandOverlayDeferredErrorVO,
  RoomBrandOverlayDeleteEventVO,
  RoomBrandOverlaySetEventVO
} from "@youm-front/room/domain";

export const roomBrandOverlaySetEvent = createAction(
  "[Room] Room Brand Overlay Set Event",
  props<{ roomBrandOverlaySetEventVO: RoomBrandOverlaySetEventVO }>()
);

export const roomBrandOverlayDeleteEvent = createAction(
  "[Room] Room Brand Overlay Delete Event",
  props<{ roomBrandOverlayDeleteEventVO: RoomBrandOverlayDeleteEventVO }>()
);

export const roomBrandOverlayDeferredErrorEvent = createAction(
  "[Room] Room Brand Overlay Deferred Error Event",
  props<{
    roomBrandOverlayDeferredErrorVO: RoomBrandOverlayDeferredErrorVO;
  }>()
);
